import { EmailPreferencesResponse } from "../api/emailPreferences.api";

export const emptyState: EmailPreferencesResponse = {
  account: false,
  newsfeed: false,
  webinars: false,
  ignitionSupportAndProductUpdates: false,
  integrators: false,
  userFeedbackGroup: false,
  ignitionCommunityConference: false,
  workspace: false,
  workspacesActivity: false,
};
